import { OrgPermission } from '../../organisation/organisation-permission.js';

export const allowedFileTypes = [
  '.csv',
  '.doc',
  '.docx',
  '.eml',
  '.fax',
  '.htm',
  '.html',
  '.img',
  '.jpeg',
  '.jpg',
  '.json',
  '.mht',
  '.mhtml',
  '.msg',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.pst',
  '.rtf',
  '.tif',
  '.txt',
  '.xls',
  '.xlsb',
  '.xlsx',
  '.zip',
  '.xlsm',
];

/** File types offered only to orgs holding the corresponding feature flag. */
export const gatedFileTypes: Partial<Record<string, OrgPermission>> = {
  '.pst': OrgPermission.PstUploads,
};

/** The types an org may upload: {@link allowedFileTypes} minus flag-gated types the org lacks. */
export function permittedFileTypesForOrg(permissions: readonly OrgPermission[]): string[] {
  return allowedFileTypes.filter((ext) => {
    const gate = gatedFileTypes[ext];
    return gate === undefined || permissions.includes(gate);
  });
}
